<template>
    <div class="app">
        <Header></Header>
      <div class="main ovf problem">
        <div class="bg-color">
          <router-link to="/xieyi" >《用户服务协议》</router-link>
          <router-link to="/yinsi">《隐私政策》</router-link>
          <router-link to="/guifan">《链接内容管理规范》</router-link>
          <router-link to="/help" >《使用帮助》</router-link>
          <router-link to="/about" style="padding-bottom: 15px;border-bottom: 2px solid #008DF2;color: #008DF2">《关于我们》</router-link>
        </div>
        <div class="user-console ovf gray-back">
          <div class="wrap ovf" >
            <div class="u-lef fl ovf bgw mt20">
              <div class="u-nav ovf">
                <h4 style="text-align: left;">功能说明</h4>
                <div class="nav-list ovf">
                  <ol class="ovf new-style" >
                    <li><a @click="go_page(1)"><span class="font-style">什么是短网址</span></a></li>
                    <li><a @click="go_page(2)"><span class="font-style">免费用户和VIP用户的区别</span></a></li>
                    <li><a @click="go_page(3)"><span class="font-style">天天短网址二维码的功能说明</span></a></li>
                    <li><a @click="go_page(4)"><span class="font-style">高级功能之访问密码设置说明</span></a></li>
                    <li><a @click="go_page(5)"><span class="font-style">高级功能之地区定位功能说明</span></a></li>
                    <li><a @click="go_page(6)"><span class="font-style">高级功能之设备定位功能说明</span></a></li>
                    <li><a @click="go_page(7)"><span class="font-style">高级功能之VIP专业报表功能说明</span></a></li>
                    <li><a @click="go_page(8)" ><span class="font-style">高级功能之替换原网址功能说明</span></a></li>
                  </ol>
                </div>
              </div>
            </div>
            <div class="fr u-rig">

              <div class="fs18 pad linehei2" style="margin-top: 60px;">
                <b>天天集团</b>，为政府、企业、事业单位及高校提供高端定制软件开发外包服务,专业领域包括信息化和数字化系统开发、微信公众号开发、小程序开发、商城系统开发、新零售系统、分销系统、社区系统、外卖系统、直播系统等手机APP开发。自主团队研发系统，高效率开发产品为企事业单位节省时间，丰富的系统结构经验，提供高且可靠性强、安全性高的网站建设。
                短网址二维码生成器 (ttdwz.cc)，为客户提供短网址在线生成，短链接生成，支持批量缩短，活码二维码生成，域名拦截检测，域名被拦截自动替换长网址，免费提供API接口。<br>


                联系方式：@xiaomo556677
              </div>


            </div>
          </div>
        </div>
      </div>

      <div class="clear"></div>
        <div class="footer ovf">Copyright &copy; 2018-2020  版权所有</div>
    </div>
</template>

<script>
    import Header from "../header";
    export default {
        name: "Help",
      components: {Header},
      data() {
            return {
                demoCodeTabs: 1,
                isVip: false,
                isGuest: true,
                user_info: {},
            }
        },
        mounted() {
            const token = this.$storeLocal.get('token');
            const user_info = this.$storeLocal.get('userInfo');
            const times = Date.parse(new Date())/1000;

            if (token !== null && token !== '' && token !== undefined) {
                if (user_info.expire_date > times){
                    this.isVip = true;
                }
                this.isGuest = false;
                this.user_info = user_info;
            }
            var hash=window.location.hash;
            if(hash){
              this.go_page(hash);
            }
        },
      methods:{
         go_page(index1){
           if (typeof(index1)=='string'){
             index1=index1.replace(/#/g,'');
           }

           window.location='/help#'+index1;
           $('#problem'+index1).css("display","");
           $('#problem'+index1).siblings().css("display","none");
         },
      }
    }
</script>

<style scoped>
table{border-spacing:0}
.app{height:auto;background-color:#ffffff}
.mid{width:1200px;height:auto;margin:0 auto;padding-top:20px}
.mid h2.title{border-left:4px solid #008bff;height:20px;line-height:20px;padding-left:5px;margin:10px 0 20px 0;font-size:22px;font-weight:500}
.apidoc-content{list-style:none;padding-left:40px}
.apidoc-content h3{margin:20px 0 10px 0;color:rgba(0,0,0,0.85);font-weight:500;font-size:18px}
.apidoc-content li.square{list-style:none;margin-left:30px;list-style-type:square}
.web-table a{cursor:pointer}
.web-table table{border-bottom:1px solid #e6e6e6;table-layout:fixed}
.web-table tr th{border-top:1px solid #e6e6e6;padding:16px 5px;color:#333;vertical-align:middle;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;background-color:#f5f5f5;font-weight:normal}
.web-table tr td{border-top:1px solid #e6e6e6;padding:16px 5px;color:#666;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;vertical-align:middle;font-size:14px}
.web-table tr:hover td{background-color:#f2faff}

.ovf{overflow:hidden}
.footer{color:#666666;text-align:center;line-height:114px;margin-top:20px;}

.user-console > .wrap{position: relative;width:1200px;margin:0px auto;  }
.user-console .u-lef{width: 260px;height: 100%;position: absolute;top:0;left: 0;background:#fff;margin-top:20px;border-right: 1px solid #eee;}
.user-console .u-rig{background: #fff;margin-top:20px;width:930px;}
.u-nav:before{content: '';width: 140px;height: 1px;margin: 0 auto;background-color: #ccc;display: block;}
.u-nav:first-child:before{display: none;}
.u-nav:first-child{margin-top: 30px;}
.u-nav{padding-left:10px;}
.u-nav h4{font-size: 22px;font-weight: bold;color: #333;margin-top: 30px;}
.u-nav .nav-list{padding: 20px 0;}
.u-nav .nav-list li{height: 35px;line-height: 35px;overflow: hidden;*display: block;}
.u-nav .nav-list li.hide{display: none;}
.u-nav .nav-list li a{display: block;color: #008DF2;font-size: 0;border-left: 4px solid transparent;}
.u-nav .nav-list li a span{font-size: 14px;display: inline-block;vertical-align: middle;font-weight: bold;}
.u-nav .nav-list li a i{display: inline-block;vertical-align: middle;margin-right: 10px;margin-left: 35px;}

.u-nav .nav-list li a:hover{color: #008df2;}
.u-nav .nav-list li a:hover i{background-position: center bottom;}
.u-nav .nav-list li.on a{color: #008df2;background-color: #edf5fa;border-left-color:#008df2;}
.u-nav .nav-list li.on a i{background-position: center bottom;}

.problem .problem-style{height:auto;}


.problem-img img{width:100%;height:auto;}
</style>
